function read_details() {
    let config = require('../webInfo.json')
	return config;
}

export default read_details;
